/* eslint-disable react-hooks/exhaustive-deps */

import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import home from '../../assets/home.svg'
import apart from '../../assets/apart.svg'
import office from '../../assets/office.svg'
import { useNavigate } from "react-router-dom";
import imageAdd from '../../assets/imageAdd.svg'
import yellowcheck from '../../assets/yellowcheck.svg'
import close from '../../assets/close2.svg'
import circleback from '../../assets/circleback.svg'
import down from '../../assets/down.svg'
import "react-datepicker/dist/react-datepicker.css";
import { CSSTransition } from 'react-transition-group';
import spinner from '../../assets/spinner.gif'

export const PageSetVenue = () => {

    const [detail,setDetail] = useState()
    const [prefix, setPrefix] = useState()
    const [phoneNumber, setPhoneNumber] = useState()
    const [addressChoosen, setAddressChoosen] = useState("Select Address")
    const history = useNavigate()
    const [venueName, setVenueName] = useState('')
    const [address, setAddress] = useState('')
    const [addressDetail, setAddressDetail] = useState('')
    const [type, setType] = useState('')
    const [image,setImage] = useState()
    const [image2,setImage2] = useState()
    const [image3,setImage3] = useState()
    const [imgprev, setImgprev] = useState()
    const [imgprev2, setImgprev2] = useState()
    const [imgprev3, setImgprev3] = useState()
    const prefixAvailable = ["+62","+65"]
    const [showPrefix, setShowPrefix] = useState(false)
    const [showAddress, setShowAddress] = useState(false)
    const [val1, setval1] = useState(false)
    const [val2, setval2] = useState(false)
    const [val3, setval3] = useState(false)
    const [val4, setval4] = useState(false)
    const [val5, setval5] = useState(false)
    const [loading, setLoading] = useState(true)
    const firstUpdate2 = useRef(true);
    const firstUpdate = useRef(true);
    const firstUpdate3 = useRef(true);
    const [showNavPopup, setShowNavPopup] = useState(false)
    
    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        setDetail({prefix:"+62",phoneNumber:"89567488573",listAddress:["Jalan Margonda Raya no 12, Depok","Jalan Radio Dalam no 17, Kebayoran Baru, Jakarta Selatan"]})
        localStorage.setItem('nav', 'fnd')
    },[])

    useEffect(() => {
        if (firstUpdate2.current) {
            firstUpdate2.current = false;
        }else{
            setLoading(false)
            setPrefix(detail.prefix)
            setPhoneNumber(detail.phoneNumber)
        }
    },[detail])

    const openPopup = (e) => {
        if(e==="prefix"){
            setShowPrefix(true)
            setShowAddress(false)
        }else{
            setShowAddress(true)
            setShowPrefix(false)
        }
    }

    useEffect(()=>{
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else{
            var elem = document.getElementById("PSVprefix");
            if(showPrefix===true){
                elem.className = "PSVprefix PSVyellow";
            }else{
                elem.className = "PSVprefix";
            }
        }
    },[showPrefix])

    useEffect(()=>{
        if (firstUpdate3.current) {
            firstUpdate3.current = false;
        }else{
            var elem = document.getElementById("PSVchoose");
            var elem2 = document.getElementById("PSVchoosedown");
            elem2.style.transition = "transform 0.5s"
            var defaultclassname = elem.className
            if(showAddress===true){
                elem.className = defaultclassname + " PSVyellow"
                elem2.style.transform = "rotate(180deg)"
            }else{
                elem.className = defaultclassname.replace("PSVyellow","")
                elem2.style.transform = "rotate(0deg)"
            }
        }
    },[showAddress])

    const handleChooseAddress = (e) => {
        setAddressChoosen(e)
        var elem = document.getElementById("PSVchoose");
        elem.className = "PSVchoose tiny black flex";
        var elem2 = document.getElementById("PSVenterAddress");
        elem2.disabled = true
        setAddress(e)
    }

    const handleSubmit = () => {
        let isError=false
        var elem = document.getElementById("PSVphone");
        var elem2 = document.getElementById("PSVchoose");
        var elem3 = document.getElementById("PSVname");
        var elem4 = document.getElementById("PSVenterAddress")
        if(phoneNumber === ''){
            elem.className = "PSVphone tiny PSVred";
            isError=true
            setval1(true)
        }else{
            elem.className = "PSVphone tiny";
            setval1(false)
        }if(addressChoosen === "Select Address"){
            if(address === ''){
                elem2.className = "PSVchoose verytiny grey flex PSVred";
                elem4.className = "PSVform tiny PSVred"
                isError=true
                setval2(true)
            }else{
                elem2.className = "PSVchoose verytiny grey flex";
                elem4.className = "PSVform tiny"
                setval2(false)
            }
        }else{
            elem2.className = "PSVchoose verytiny grey flex";
            elem4.className = "PSVform tiny"
            setval2(false)
        }if(venueName===''){
            elem3.className = "PSVform tiny PSVred";
            isError=true
            setval3(true)
        }else{
            elem3.className = "PSVform tiny";
            setval3(false)
        }if(type===''){
            isError=true
            setval4(true)
        }else{
            setval4(false)
        }if(!image || !image2 || !image3){
            isError=true
            setval5(true)
        }else{
            setval5(false)
        }

        if(isError){
            return
        }else{
            localStorage.setItem('address',address)
            localStorage.setItem('phoneNumber', phoneNumber)
            localStorage.setItem('prefix', prefix)
            setstandby(false)
        }
    }

    const [standby, setstandby] = useState(true)
    useEffect(()=>{  
        if(standby===false){
            setTimeout(function() {
                history("/category/chefList/detailChef/detailMenu/setSchedule/setVenue/submitBooking")
           }, 500);
        }
    },[standby])

    const handleCloseAll = () => {
        setShowAddress(false)
        setShowPrefix(false)
        setShowNavPopup(false)
    }

    

    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <img onClick={e => {e.preventDefault();e.stopPropagation();history(-1)}} className='backmobile' alt="back" src={circleback}></img>
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="PSVtrans">
                <div className='PSVcontainer'>
                    <p className='big bold white PSVtittle'>Set Venue</p>
                    <div className='PSVflex flex'>
                        <div className='PSVkontainerkiri'>
                            <div className='PSVkontenwrapper'>
                                <p className='medium'>Phone Number</p>
                                <div className='flex' style={{marginTop:"8px"}}>
                                    <div id="PSVprefix" onClick={e => {e.preventDefault();e.stopPropagation();showPrefix?setShowPrefix(false):openPopup("prefix")}} className='PSVprefix'>
                                        <p className='tiny'>{prefix}</p>
                                        {
                                            showPrefix && (
                                                <div className='PSVpopup'>
                                                    {prefixAvailable.map((post) => (
                                                        <p onClick={e => {e.preventDefault();e.stopPropagation();setPrefix(post);setShowPrefix(false)}} className='tiny' style={{marginBottom:"8px", cursor:"pointer"}}>{post}</p>
                                                    )
                                                    )}
                                                </div>
                                            )
                                        }
                                    </div>
                                    <input onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll()}} id="PSVphone" type="text" className='PSVphone tiny' value={phoneNumber} onChange={e => setPhoneNumber(e.target.value.replace(/\D/g, ''))} placeholder="Phone Number"></input>
                                </div>
                                {
                                    val1 && (
                                        <p className='bold verytiny' style={{color:"#FA591D", marginTop:"8px", marginBottom:"8px", textAlign:"right"}}>Please input your phone number!</p>
                                    )
                                }
                                <p className='medium PSVmargin'>Choose Address</p>
                                <div  id="PSVchoose" onClick={e => {e.preventDefault();e.stopPropagation();showAddress?setShowAddress(false):openPopup("address")}} className='PSVchoose verytiny grey flex' style={{marginTop:"8px"}}>{addressChoosen}
                                <img id="PSVchoosedown"  alt='icon' className='PSVicon3' src={down}></img>
                                
                                </div>
                                {
                                    val2 && (
                                        <p className='bold verytiny' style={{color:"#FA591D", marginTop:"8px", marginBottom:"8px", textAlign:"right"}}>Please select the address or input manually on "Enter Address"!</p>
                                    )
                                }
                                <div style={{position:"relative"}}>
                                {
                                    showAddress && (
                                        <div className='PSVpopup' style={{marginTop:"8px"}}>
                                            {detail.listAddress.map((post) => (
                                                <p onClick={e => {e.preventDefault();e.stopPropagation();handleChooseAddress(post);setShowAddress(false)}} className='tiny' style={{marginBottom:"16px", cursor:"pointer"}}>{post}</p>
                                            )
                                            )}
                                        </div>
                                    )
                                }
                                </div>

                                <p className='medium PSVmargin'>Venue Name</p>
                                <input onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll()}} id="PSVname" type='text' className='PSVform tiny' style={{marginTop:"8px"}} value={venueName} onChange={e => setVenueName(e.target.value)} placeholder="*i.e Jason's House / My Villa"></input>
                                {
                                    val3 && (
                                        <p className='bold verytiny' style={{color:"#FA591D", marginTop:"8px", marginBottom:"8px", textAlign:"right"}}>Please input your venue name!</p>
                                    )
                                }
                                <p className='medium PSVmargin'>Select Venue Profile</p>
                                <div className='flex' style={{marginTop:"8px"}}>
                                    {type==="home"?
                                        <div className='PSVprofile2'>
                                            <img alt="icon" className='PSVicon' src={home}></img>
                                            <p className='verytiny'>Home</p>
                                            <img alt='icon' className='PSVicon2' src={yellowcheck}></img>
                                        </div>
                                    :
                                    <div onClick={e => {e.preventDefault();e.stopPropagation();setType('home');handleCloseAll();}} className='PSVprofile'>
                                        <img alt="icon" className='PSVicon' src={home}></img>
                                        <p className='verytiny'>Home</p>
                                    </div>
                                    }

                                    {type==="apart"?
                                    <div className='PSVprofile2' style={{marginLeft:"auto"}}>
                                        <img alt="icon" className='PSVicon' src={apart}></img>
                                        <p className='verytiny'>Apartment</p>
                                        <img alt='icon' className='PSVicon2' src={yellowcheck}></img>
                                    </div>
                                    :
                                    <div onClick={e=>{e.preventDefault();e.stopPropagation();setType('apart');handleCloseAll()}} className='PSVprofile' style={{marginLeft:"auto"}}>
                                        <img alt="icon" className='PSVicon' src={apart}></img>
                                        <p className='verytiny'>Apartment</p>
                                    </div>
                                    }
                                
                                    {
                                        type==="office"?
                                        <div className='PSVprofile2' style={{marginLeft:"auto"}}>
                                            <img alt="icon" className='PSVicon' src={office}></img>
                                            <p className='verytiny'>Office</p>
                                            <img alt='icon' className='PSVicon2' src={yellowcheck}></img>
                                        </div>
                                        :
                                        <div onClick={e => {e.preventDefault();e.stopPropagation();setType('office');handleCloseAll();}} className='PSVprofile' style={{marginLeft:"auto"}}>
                                            <img alt="icon" className='PSVicon' src={office}></img>
                                            <p className='verytiny'>Office</p>
                                        </div>
                                    } 
                                    
                                </div>
                                {
                                    val4 && (
                                        <p className='bold verytiny' style={{color:"#FA591D", marginTop:"8px", marginBottom:"8px", textAlign:"right"}}>Please select your venue type!</p>
                                    )
                                }
                            </div>
                        </div>

                        <div className='PSVkontainerkiri'>
                            <div className='PSVkontenwrapper'>
                                <p className='medium'>Enter Address</p>
                                <textarea onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll()}} id="PSVenterAddress" type='text' className='PSVform tiny' rows="5" style={{marginTop:"8px"}} value={address} onChange={e => setAddress(e.target.value)} placeholder="Enter a Location"></textarea>
                                <p className='medium PSVmargin'>Address Detail</p>
                                <textarea onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll()}} type='text' className='PSVform tiny' rows="5" style={{marginTop:"8px"}} value={addressDetail} onChange={e => setAddressDetail(e.target.value)} placeholder="Kindly enter any informatioon about your Venue/Kitchen/Dining Area that will help the Taplak partner maximise eour experience"></textarea>
                                <p className='medium PSVmargin'>Venue Picture</p>
                                <div className='flex' style={{marginTop:"8px"}}>
                                    <div style={{width:"30%"}}>
                                        <label  for="inputFile" style={{backgroundImage:`url(${imgprev})`}} className='PSVimageadd'>
                                            {imgprev?
                                                <img onClick={(e) => {e.preventDefault();e.stopPropagation();setImage();setImgprev()}} alt="icon" className='PSVicon2' src={close}></img>
                                                :
                                                <img alt="icon" className='PSVicon' src={imageAdd}></img>
                                            }
                                        </label>  
                                        <label for="inputFile" className='verytiny PSVimagebutton'>Choose file</label>
                                        <input type="file" id="inputFile" onChange={e => {e.preventDefault();e.stopPropagation();setImage(e.target.files[0]);setImgprev(URL.createObjectURL(e.target.files[0]))}} style={{display:"none"}} accept="image/*"></input>
                                    </div>
                                    
                                    <div style={{width:"30%", marginLeft:"auto"}}>
                                        <label for="inputFile2" style={{backgroundImage:`url(${imgprev2})`}} className='PSVimageadd'>
                                            {imgprev2?
                                                <img onClick={(e) => {e.preventDefault();e.stopPropagation();setImage2();setImgprev2()}} alt="icon" className='PSVicon2' src={close}></img>
                                                :
                                                <img alt="icon" className='PSVicon' src={imageAdd}></img>
                                            }
                                        </label>  
                                        <label for="inputFile2" className='verytiny PSVimagebutton'>Choose file</label>
                                        <input type="file" id="inputFile2" onChange={e => {e.preventDefault();e.stopPropagation();setImage2(e.target.files[0]);setImgprev2(URL.createObjectURL(e.target.files[0]))}} style={{display:"none"}} accept="image/*"></input>
                                    </div>

                                    <div style={{width:"30%", marginLeft:"auto"}}>
                                        <label for="inputFile3" style={{backgroundImage:`url(${imgprev3})`}} className='PSVimageadd'>
                                            {imgprev3?
                                                <img onClick={(e) => {e.preventDefault();e.stopPropagation();setImage3();setImgprev3()}} alt="icon" className='PSVicon2' src={close}></img>
                                                :
                                                <img alt="icon" className='PSVicon' src={imageAdd}></img>
                                            }
                                        </label>  
                                        <label for="inputFile3" className='verytiny PSVimagebutton'>Choose file</label>
                                        <input type="file" id="inputFile3" onChange={e => {e.preventDefault();setImage3(e.target.files[0]);setImgprev3(URL.createObjectURL(e.target.files[0]))}} style={{display:"none"}} accept="image/*"></input>
                                    </div>
                                </div>
                                {
                                    val5 && (
                                        <p className='bold verytiny' style={{color:"#FA591D", marginTop:"16px", marginBottom:"8px", textAlign:"right"}}>Please input 3 photos of your venue!</p>
                                    )
                                }
                            </div>
                            <button onClick={e => {e.preventDefault();e.stopPropagation();handleSubmit()}} className='bold small PSVbutton PSVmargin'>Continue</button>
                        </div>
                    </div>

                </div>
                </CSSTransition>
            }  
        </div>
    )
  }